import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import toast from 'react-hot-toast';
import { getPreUrlAddDocs } from 'services/apiReport';

const useGetPreSignedUrlAddDocs = () => {
    const queryClient = useQueryClient();

    const{isPending:isGetting,isSuccess:isGot,mutateAsync:getPreSignedUrl} = useMutation({
        mutationFn:(formData)=> getPreUrlAddDocs(formData),
        onSuccess:(data)=>{
            queryClient.setQueryData(["urlAddocs"],data)
            // localStorage.setItem("sucessUploadData",JSON.stringify(data.file))
            // localStorage.setItem("count",JSON.stringify(data.order_count))
            // toast.success("Upload Successful")
        },
        onError:(error)=>{
            toast.error(error?.data?.message || "An error occurred while generating the pre signed url")
        console.error("Error occurred:",error)
        }
        
    })

    return{isGetting,isGot,getPreSignedUrl}
}

export default useGetPreSignedUrlAddDocs